<style scoped>
.ivu-radio-wrapper{
    font-size: 12px;
    vertical-align: top;
}
</style>
<template>
    <div>
        <!-- inquiry -->
        <div v-if="boxtype == 'typeinquiry'">
            <!-- 添加Inquiry -->
            <div>
                <vForm :label-width="120" ref="form" class="margin-15 clearfix">
                    <div v-for="(item,index) in companyList" :key="index">
                        <vCol span="24">
                            <vFormItem :label="$t('fbb.headlogistics.transport_type', { defaultValue: '发运方式' })">
                                <vSelect v-model="item.shipType">
                                    <vOption value="1">LTL</vOption>
                                    <vOption value="2">FTL</vOption>
                                </vSelect>
                            </vFormItem>
                        </vCol>
                        <vCol span="24">
                            <vCol span="12">
                                <vFormItem :label="$t('fbb.truck.company', { defaultValue: '卡车公司' })+'1'" :rules="required" prop="company">
                                    <span v-if="querytype=='query'">{{item.company}}</span>
                                    <Input v-else v-model="item.company"></Input>
                                </vFormItem>
                                <vFormItem :label="$t('erp.b2c.money', { defaultValue: '金额' })" :rules="required" prop="amount">
                                    <span v-if="querytype=='query'">{{item.amount}}</span>
                                    <Input v-else v-model="item.amount"></Input>
                                </vFormItem>
                                <vFormItem :label="$t('erp.b2border.refNo', { defaultValue: '参考号' })" >
                                    <span v-if="querytype=='query'">{{item.referenceNo}}</span>
                                    <Input v-else v-model="item.referenceNo"></Input>
                                </vFormItem>
                            </vCol>
                            <vCol span="12">
                                <vFormItem :label="$t('fbb.truck.company', { defaultValue: '卡车公司' })+'2'" >
                                    <span v-if="querytype=='query'">{{item.company2}}</span>
                                    <Input v-else v-model="item.company2"></Input>
                                </vFormItem>
                                <vFormItem :label="$t('erp.b2c.money', { defaultValue: '金额' })" >
                                    <span v-if="querytype=='query'">{{item.amount2}}</span>
                                    <Input v-else v-model="item.amount2"></Input>
                                </vFormItem>
                                <vFormItem :label="$t('erp.b2border.refNo', { defaultValue: '参考号' })" >
                                    <span v-if="querytype=='query'">{{item.referenceNo2}}</span>
                                    <Input v-else v-model="item.referenceNo2"></Input>
                                </vFormItem>
                            </vCol>
                        </vCol>
                    </div>
                </vForm>
            </div>
            <div class="text-right">
                <vButton class="margin-right-10" theme="info" @click="addItem">{{$t('fbb.headlogistics.continue_add',{defaultValue:'继续添加'})}}</vButton>
                <vButton class="margin-right-10" theme="primary" @click="sunbmit">{{$t('global.modal.confirm', { defaultValue: "确定" })}}</vButton>
                <vButton @click="cancel">{{$t('global.common.operate_cancel', { defaultValue: "取消" })}}</vButton>
            </div>
        </div>
        <!-- cancel -->
        <div v-else-if="boxtype === 'typecancel'">
            <vFormItem :label="$t('global.common.notes', { defaultValue: '备注' })" :rules="required" prop="remark">
                <vTextarea v-model="remark"></vTextarea>
            </vFormItem>
            <div class="text-right margin-top-10">
                <vButton class="margin-right-10" theme="primary" @click="sunbmitcancel">{{$t('global.modal.confirm', { defaultValue: "确定" })}}</vButton>
                <vButton @click="cancel">{{$t('global.common.operate_cancel', { defaultValue: "取消" })}}</vButton>
            </div>
        </div>
        <!-- confirm -->
        <div v-else>
            <div v-for="(json,index) in newtruckList" :key="index" class="clearfix">
                <vCol span="24">
                    <vCol span="6">
                        <vButton v-if="json.status == 2" theme="error" class="margin-bottom-5" disabled>{{$t('fbb.truck.choosed', { defaultValue: '已选中' })}}</vButton>
                        <vButton v-else theme="primary" class="margin-bottom-5" @click="clickchoose(json,index)">{{$t('fbb.truck.choose', { defaultValue: '选中' })}}</vButton>
                    </vCol>
                    <vCol span="6" style="margin-top:10px">
                        {{$t('fbb.truck.company', { defaultValue: '卡车公司' })}}：{{json.company}}
                    </vCol>
                    <vCol span="6" style="margin-top:10px">
                        {{$t('erp.b2border.refNo', { defaultValue: '参考号' })}}：{{json.referenceNo?json.referenceNo:'--'}}
                    </vCol>
                </vCol>
                <vCol style="margin-left:137px;margin-bottom:0px" span="12" v-if="json.status == 2">
                    {{$t('fbb.truck.realamount', { defaultValue: '应收金额' })}}：{{receiveAmount}}
                </vCol>
                <vCol style="margin-left:137px;margin-bottom:0px" span="12" v-if="json.status == 2">
                    {{$t('', { defaultValue: '应收保险金额' })}}：{{receiveInsuranceAmount}}
                </vCol>
                <vCol span="24" v-if="json.status == 2" class="margin-bottom-20">
                    <Form class="search-other" :label-width="120" inline ref="form">
                        <vCol span="12" >
                            <FormItem label='提货仓是否需要预约'>
                                <RadioGroup v-model="pickReserve">
                                    <Radio :label="1">是</Radio>
                                    <Radio :label="0">否</Radio>
                                </RadioGroup>
                            </FormItem>
                        </vCol>
                        <vCol span="12" >
                            <FormItem label='送货仓是否需要预约'>
                                <RadioGroup v-model="deliverReserve">
                                    <Radio :label="1">是</Radio>
                                    <Radio :label="0">否</Radio>
                                </RadioGroup>
                            </FormItem>
                        </vCol>
                        <vCol span="12" >
                            <FormItem label='金额(应收)是否结算'>
                                <RadioGroup v-model="isReceiveBill">
                                    <Radio :label="1">是</Radio>
                                    <Radio :label="0">否</Radio>
                                </RadioGroup>
                            </FormItem>
                        </vCol>
                        <vCol span="12" >
                            <FormItem label='金额(应付)是否结算'>
                                <RadioGroup v-model="isPayBill">
                                    <Radio :label="1">是</Radio>
                                    <Radio :label="0">否</Radio>
                                </RadioGroup>
                            </FormItem>
                        </vCol>
                        <vCol span="12" >
                            <FormItem label='其他提货、送货要求'>
                                <Input v-model="elseRequire"></Input>
                            </FormItem>
                        </vCol>
                        <vCol span="12" >
                            <FormItem label='可提货时间'>
                                <vDatepicker type="date" format='yyyy-mm-dd' v-model="pickUpReserve"></vDatepicker>
                            </FormItem>
                        </vCol>
                    </Form>

                </vCol>
            </div>
            <div class="text-right margin-top-10">
                <vButton class="margin-right-10" theme="primary" @click="sunbmitchoose">{{$t('global.modal.confirm', { defaultValue: "确定" })}}</vButton>
                <vButton @click="cancel">{{$t('global.common.operate_cancel', { defaultValue: "取消" })}}</vButton>
            </div>
        </div>
    </div>
</template>

<script>
import { HttpInquiryTruckOne,HttpConfirmTruck,HttpCancelTruckOne,HttpTruckGetAmount } from "@/service/bespeak";

export default {
    props:['boxtype','querytype','orderid','truckList'],
    data(){
        return {
            formData:{},
            companyList:[{
                shipType:'',
                company1:'',
                amount1:'',
                referenceNo1:'',
                company2:'',
                amount2:'',
                referenceNo2:'',
            }],
            required: [{
                required: true,
                message: this.$t('global.common.fill_requiredd',{defaultValue:'该信息不能为空,请填写'})
            }],
            inquiryId:null,
            receiveAmount:'',
            pickReserve:0,
            deliverReserve:0,
            isReceiveBill:1,
            isPayBill:0,
            elseRequire:'',
            pickUpReserve:'',
            newtruckList:[],
        }
    },
    created(){
        this.newtruckList = [...this.truckList]
    },
    mounted(){

    },
    methods:{
        addItem(){
            let datajson = {
                shipType:'',
                company1:'',
                amount1:'',
                referenceNo1:'',
                company2:'',
                amount2:'',
                referenceNo2:'',
            }
            this.companyList.push(datajson)
        },
        clickchoose(row,itemindex){
            this.newtruckList.map((item,itemindex)=>{
                if(item.id == row.id){
                    this.inquiryId = row.id
                    this.$set(this.newtruckList,itemindex,{...item,status:2});
                }else{
                    this.$set(this.newtruckList,itemindex,{...item,status:1});
                }
            })
            HttpTruckGetAmount({
                truckReservationId:this.orderid,
                shipType:row.shipType,
                amount:row.amount,
                insuranceAmount:row.insuranceAmount
            }).then(res=>{
                this.receiveInsuranceAmount=res.data.receiveInsuranceAmount
                this.receiveAmount=res.data.receiveAmount
            })
        },
        sunbmitcancel(){
            if(!this.remark){
                this.$VMessage.error('请填写备注!');
                return;
            }
            HttpCancelTruckOne({
                id:this.orderid,
                remark:this.remark
            }).then(res=>{
                this.$VMessage.success(res.message);
                this.$emit('on-update')
                this.cancel()
            },err=>{
                this.$VMessage.error(err.message);
            })
        },
        sunbmitchoose(){
            if(!this.receiveAmount){
                this.$VMessage.error('请填写应收金额!');
                return;
            }
            if(!this.pickUpReserve){
                this.$VMessage.error('请选择提货时间!');
                return;
            }
            HttpConfirmTruck({
                truckReservationId:this.orderid,
                inquiryId:this.inquiryId,
                receiveAmount:this.receiveAmount,
                pickReserve:this.pickReserve,
                deliverReserve:this.deliverReserve,
                isReceiveBill:this.isReceiveBill,
                isPayBill:this.isPayBill,
                elseRequire:this.elseRequire,
                pickUpReserve:this.pickUpReserve,
                receiveInsuranceAmount:this.receiveInsuranceAmount
            }).then(res=>{
                this.$VMessage.success(res.message);
                this.$emit('on-update')
                this.cancel()
            },err=>{
                this.$VMessage.error(err.message);
            })
        },
        sunbmit(){
            HttpInquiryTruckOne({
                id:this.orderid,
                truckReservationInquirys:this.companyList
            }).then(res=>{
                this.$VMessage.success(res.message);
                this.$emit('on-update')
                this.cancel()
            },err=>{
                this.$VMessage.error(err.message);
            })
        },
        cancel(){
            this.$emit('on-close')
        },
    }
}
</script>

